import Logger from '@tools/logger/logger';
import requests from '@tools/requests-mixin';
import { flashBagError, flashBagSuccess } from '@tools/flashbag';

export default {
  data() {
    return {
      sendEmailValidationLoading: false,
    };
  },
  mixins: [ requests ],
  methods: {
    sendEmailValidation(event) {
      event.preventDefault();
      if (!this.sendEmailValidationLoading) {
        this.sendEmailValidationLoading = true;
        const sendEmailLink = `${event.target.href}?json=true`;
        this.get(sendEmailLink)
          .then((response) => {
            const { message } = response.data;
            flashBagSuccess(message);
          })
          .catch((error) => {
            flashBagError();
            Logger.error('Error occurred', error);
          })
          .finally(() => {
            this.sendEmailValidationLoading = false;
          });
      }
    },
  },
};
